import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-table-plan-price',
  template: `
    <div *ngIf="payment_duration !== 0">
      <!--<s class="canceled-price-label">{{plan_price}}</s><br/>-->
      <span class="price-label">
        <!--<strong>{{base_discount_plan_price}}</strong>-->
        <strong>
          $<span>{{base_val}}</span>
          <sup style="font-size: 10px;"><strong>{{cent_val}}</strong></sup>
          <span>/mo</span>
        </strong>
      </span>

    </div>
    <div *ngIf="payment_duration == 0">
      <span class="price-label"><strong>{{plan_price}}</strong></span>
    </div>
  `,
  styles: []
})
export class TablePlanPriceComponent implements  OnInit {

  @Input() rowData: any;

  payment_duration: any;
  base_discount_plan_price: any;
  plan_price: any;

  base_val: any;
  cent_val: any;

  ngOnInit() {
    this.payment_duration = this.rowData.payment_duration;
    this.base_discount_plan_price = '$' + this.rowData.base_discount_plan_price + '/mo';
    this.plan_price = '$' + this.rowData.plan_price + '/mo';


    let base_price = this.rowData.base_discount_plan_price ;
    if(base_price !== undefined){
      base_price = base_price.toString();
      base_price = base_price.split('.');
      this.base_val = base_price[0];
      this.cent_val = base_price[1];
    }

  }

}
